/* market/accommodations */
import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    accommodations_beginDate: null,
    accommodations_lastDate: null,
    accommodations_datasets: [],
    accommodations_hotel_per_location: [],
    accommodations_hotel_type: [],
    //v2
    accommodation_isLoading: false,
    accommodation_type_x_location_province: {},
    accommodation_type: {},
    accommodations_table: null,
    accommodations_total: 0,
    accommodation_type: [],
}

// getters
const getters = {
    accommodations_date: state => {        
        return { start: state.accommodations_beginDate, end: state.accommodations_lastDate }
    },
    accommodation_isLoading: state => {
        return state.accommodation_isLoading;
    },
    accommodations_data_date: state => {  
        return "N/A"      
        if (state.accommodations_beginDate !== null) {
            var _start = state.accommodations_beginDate.split("T");
            var _end = state.accommodations_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        } else {
            return "N/A"
        }
    },
    accommodations_datasets: state => {
        return state.accommodations_datasets;
    },
    accommodations_hotel_per_location: state => {
        return state.accommodations_hotel_per_location;
    },
    accommodations_hotel_type: state => {
        return state.accommodations_hotel_type;
    },
    accommodations_table: state => {
        return state.accommodations_table;
    }
}

// actions
const actions = {
    V2getAccommodationsDatasets(context, payload) {
        state.accommodation_isLoading = true;
        state.accommodations_country_filter = [];

        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };

        // query data
        instance.get('v2/market/accommodation', request)
            .then(response => {
                const {
                    accommodation_type_x_location_province,
                    accommodation_type,
                } = response.data;

                state.accommodations_beginDate = moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
                state.accommodations_lastDate = moment().endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
                state.accommodation_type_x_location_province = accommodation_type_x_location_province;
                state.accommodation_type = accommodation_type;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "accommodations_hotel_per_location") {
                        context.commit("V2onAccommodationsHotelPerLocation", payload);
                    } else if (stateName == "accommodations_hotel_type") {
                        context.commit("V2onAccommodationsHotelType", payload);
                    }
                })
                state.accommodation_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/market/accommodation] syntax errors under instant.get");
            })
    },
    getAccommodationsDatasets(context, payload) {
        // share with accommodations/53 [chart/table]
        // console.log("[store/market/accommodations] getAccommodationsDatasets() DEPRECATED - excepted /accommodations/53");

        state.accommodation_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_destination != null) {
                _params.location_province = main_filters.location_destination;
            }
        }

        // calulate _params from sub_filters
        // accommodation_standard, accommodation_rate, accommodation_type, q, limit, page, sort
        _params.limit = 5;
        _params.page = 1;
        var sub_filter = payload.sub_filter;
        if (sub_filter !== null) {
            if (sub_filter.accommodation_standard !== null) {
                _params.accommodation_standard = sub_filter.accommodation_standard;
            }
            if (sub_filter.accommodation_rate !== null) {
                _params.accommodation_rate = sub_filter.accommodation_rate;
            }
            if (sub_filter.accommodation_type !== null) {
                _params.accommodation_type = sub_filter.accommodation_type;
            }
            if (sub_filter.q !== "") {
                _params.q = sub_filter.q;
            }
            if (sub_filter.limit > 0) {
                _params.limit = sub_filter.limit;
            }
            if (sub_filter.page > 0) {
                _params.page = sub_filter.page;
            }
            if (sub_filter.sort != "") {
                _params.sort = sub_filter.sort;
            }
        }

        const request = {
            params: qs.parse(_params)
        };

        instance.get('market/accommodations', request)
            .then(response => {
                const { accommodation_type, count, rows } = response.data;
                state.accommodations_datasets = rows;
                state.accommodations_total = count;
                state.accommodation_type = accommodation_type;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "accommodations_table") {
                        context.commit("onAccommodationsTable", payload);
                    }
                })
                state.accommodation_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/market/accommodations] syntax errors under instant.get");
            })
    },
}

// mutations
const mutations = {

    V2onAccommodationsHotelPerLocation(state, payload) {
        // --- start dataset for jvector map
        // items = [{accommodation_type:[{label0:value0},{label1:value1}...],data:0,label:'',location_destination:'',percentage:0},...]
        var rows = state.accommodation_type_x_location_province.rows;
        var items = [];
        var total = 0;

        rows.forEach(function(item, index) {
            var _item = {};
            var _accommodation_type = item._id.accommodation_type;
            var pos = items.map(function(e) {
                return e.location_destination;
            }).indexOf(item._id.location_province);

            total += item.sum_accommodation;
            if (pos == -1) {
                _item['location_destination'] = item._id.location_province
                _item['label'] = item._id.location_province;
                _item['data'] = item.sum_accommodation;
                _item['accommodation_type'] = {};
                _item['accommodation_type'][_accommodation_type] = item.sum_accommodation;
                items.push(_item);
            } else {
                items[pos]['data'] += item.sum_accommodation;
                if (items[pos]['accommodation_type'][_accommodation_type] != undefined) {
                    items[pos]['accommodation_type'][_accommodation_type] += item.sum_accommodation;
                } else {
                    items[pos]['accommodation_type'][_accommodation_type] = item.sum_accommodation;
                }
            }
        });

        items.forEach(function(item, index) {
            var percentage = ((item.data / total) * 100);
            items[index].percentage = percentage;
            items[index].location_destination = items[index].label;
            items[index].label = items[index].label.toUpperCase() + " " + numeral(percentage).format('0,0.00') + "% (" + numeral(item.data).format('0,0') + ")";
            // star - sort item.accommodation_type by key asc            
            var _keys = Object.keys(item.accommodation_type);
            var _sort_accommodation_type = {};
            var _len = _keys.length;
            _keys.sort(function(a, b) {
                return a.localeCompare(b);
            })
            for (var i = 0; i < _keys.length; i++) {
                _sort_accommodation_type[_keys[i]] = item.accommodation_type[_keys[i]];
            }
            items[index].accommodation_type = _sort_accommodation_type;
            // end - sort item.accommodation_type by key asc            
        });
        state.accommodations_hotel_per_location = items
        // --- end dataset for jvector map
    },

    V2onAccommodationsHotelType(state, payload) {
        // --- start dataset for doughnut chart
        // items = [{data:number,label:string,color:string}]
        var rows = state.accommodation_type.rows;
        var items = [];
        var total = 0;
        rows.forEach(function(item, index) {
            total += item.sum_accommodation;
            var _item = { data: item.sum_accommodation, label: item._id.accommodation_type };
            items.push(_item);
        });
        // sort accommodation_type asc
        items.sort(function(a, b) {
            return a.label.localeCompare(b.label);
        });
        if (total == 0) {
            items = [];
        }
        state.accommodations_hotel_type = items
        // --- end dataset for doughnut chart
    },

    onAccommodationsTable(state, payload) {
        // --- start dataset for v-data-table
        /**
        {
            "id": "5be436883ea5940006543f6a",
            "accommodation_type": "อื่นๆ",
            "accommodation_name": "Life_of_Hoi อื่นๆ",
            "accommodation_telephone": "025-5554-4520",
            "accommodation_address": "120/22 navamin Bngkok",
            "accommodation_website": "https://hailand-hotel.com",
            "accommodation_low_rate": 2500,
            "accommodation_high_rate": 10000,
            "accommodation_standard": "4",
            "location_zone": "เอเชีย",
            "location_source": "ไทย",
            "location_province": "ปราจีนบุรี
        }
        */
        var rows = state.accommodations_datasets;
        var accommodations_datatable = {
            headers: [
                { text: 'Name', value: "accommodation_name", align: 'left' },
                { text: 'Telephone', value: "accommodation_telephone", align: 'left', sortable: false },
                { text: 'Address', value: "accommodation_address", align: 'left', sortable: false },
                { text: 'Type', value: "accommodation_type", align: 'left', sortable: false, style: 'width:110px;' },
                { text: 'Standard', value: "accommodation_standard", align: 'left' },
                { text: 'Rate', value: "accommodation_rate", align: 'left', sortable: false },
                { text: 'Website', value: "accommodation_website", align: 'center', sortable: false },
            ],
            items: [{
                value: false,
                accommodation_name: '',
                accommodation_telephone: '',
                accommodation_address: '',
                accommodation_website: '',
            }],
            pagination: {
                sortBy: 'accommodation_name',
                descending: false,
            },
            total: 0,
        };

        // build items
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {
                value: false,
                accommodation_name: item.accommodation_name,
                accommodation_telephone: item.accommodation_telephone,
                accommodation_address: item.accommodation_address,
                accommodation_website: item.accommodation_website,
                accommodation_type: item.accommodation_type,
                accommodation_standard: item.accommodation_standard,
                accommodation_rate: item.accommodation_low_rate + " - " + item.accommodation_high_rate,
            }
            items.push(_item);
        });
        accommodations_datatable.items = items;
        accommodations_datatable.total = state.accommodations_total;
        accommodations_datatable.accommodation_type = state.accommodation_type.sort(function(a, b) { return a.localeCompare(b) });
        state.accommodations_table = accommodations_datatable;
        // --- start dataset for v-data-table
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}